var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"vs-bg",attrs:{"fill-height":""}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('app-content'),_vm._v(" "),_c('connection-checker'),_vm._v(" "),_c('service-worker')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dafb25a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/CanvasLayout.vue
// module id = null
// module chunks = 